import { render, staticRenderFns } from "./FulfillmentBase.vue?vue&type=template&id=29f080ba&"
import script from "./FulfillmentBase.vue?vue&type=script&lang=js&"
export * from "./FulfillmentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports